
import { defineComponent } from 'vue';
import {
  AjaxHelper,
  Matomo,
  ContentTable,
  NotificationsStore,
  translate,
} from 'CoreHome';
import { SaveButton } from 'CorePluginsAdmin';

const { $ } = window;

interface ManageSearchEnginesDataState {

  searchEngines: Record<string, unknown>,
  searchEngineNames: string[],
  userDefinedSearchEngines: Record<string, unknown>,
  searchEngineLogos: Record<string, unknown>,
  newEngineData: Record<string, string>,
  busy: boolean,
  showEngineForm: boolean,
  searchText: string,
}

export default defineComponent({
  data(): ManageSearchEnginesDataState {
    return {
      searchEngines: {},
      searchEngineNames: [],
      userDefinedSearchEngines: {},
      searchEngineLogos: {},
      newEngineData: {},
      busy: false,
      showEngineForm: false,
      searchText: '',
    };
  },
  created() {
    this.fetchSearchEngines();
  },
  directives: {
    ContentTable,
  },
  components: {
    SaveButton,
  },
  methods: {
    refreshList() {
      AjaxHelper.post(
        {
          module: 'ReferrersManager',
          action: 'refresh',
          type: 'searchengines',
        },
        {},
        { withTokenInUrl: true },
      ).then(() => {
        this.fetchSearchEngines();
      });
    },

    fetchSearchEngines() {
      if (this.busy) {
        return;
      }

      this.busy = true;

      const promises = [];

      promises.push(AjaxHelper.fetch<Record<string, unknown>>(
        {
          module: 'API',
          method: 'ReferrersManager.getSearchEngineDefinitions',
        },
      ));

      promises.push(AjaxHelper.fetch<Record<string, unknown>>(
        {
          module: 'API',
          method: 'ReferrersManager.getSearchEngineLogos',
        },
      ));

      promises.push(AjaxHelper.fetch<Record<string, unknown>>(
        {
          module: 'API',
          method: 'ReferrersManager.getUserDefinedSearchEngines',
        },
      ));

      Promise.all(promises).then(([searchEngines, logos, userDefinedData]) => {
        this.searchEngines = searchEngines;
        this.searchEngineNames = Object.keys(searchEngines);
        this.searchEngineLogos = logos;
        this.userDefinedSearchEngines = userDefinedData;
        this.busy = false;
      });
    },

    showAddSearchEngineForm(show: boolean) {
      this.showEngineForm = show;
    },

    removeEngine(host: string) {
      $('#removeDataConfirm').find('h2 .name').text(host);
      Matomo.helper.modalConfirm('#removeDataConfirm', {
        yes: () => {
          AjaxHelper.fetch(
            {
              module: 'API',
              method: 'ReferrersManager.removeSearchEngine',
              host,
            },
          ).then(() => {
            this.refreshList();
          });
        },
      });
    },

    addSearchEngine() {
      AjaxHelper.post(
        {
          module: 'API',
          method: 'ReferrersManager.addSearchEngine',
        },
        this.newEngineData,
      ).then((response) => {
        if (!response) {
          this.showAddEngineError();
          return;
        }

        // hide/reset form and refresh list
        this.showAddSearchEngineForm(false);
        this.newEngineData = {
          name: '',
          host: '',
          parameters: '',
          backlink: '',
          charset: '',
        };
        this.refreshList();
      });
    },

    truncateText(text: string, length: number) {
      if (text && text.length > length) {
        return `${text.substr(0, length - 3)}...`;
      }

      return text;
    },

    showAddEngineError() {
      NotificationsStore.show({
        message: translate('ReferrersManager_AddEngineError'),
        context: 'error',
        noclear: true,
        type: 'toast',
        style: {
          display: 'inline-block',
        },
        id: 'addEngineError',
      });
    },
  },
});
